<template>
    <el-menu :default-active="defaultActive" class="el-menu-vertical" text-color="#ffffff" active-text-color="#006eff"
        background-color="#24273b">
        <el-submenu index="1">
            <template slot="title">
                <i class="el-icon-circle-plus-outline"></i>
                <span>边缘骇客实验室</span>
            </template>
            <el-menu-item-group title="普通付费资源">
                <el-menu-item index="1-1" @click="navigateTo('/manage/instance')">服务器实例</el-menu-item>
                <el-menu-item index="1-2" @click="navigateTo('/manage/certificate')">网站域名证书</el-menu-item>
                <el-menu-item index="1-3" @click="navigateTo('/manage/record')">备案信息</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group title="增值付费资源">
                <el-menu-item index="1-4" @click="navigateTo('/manage/cloud')">付费云服务</el-menu-item>
                <el-menu-item index="1-5" @click="navigateTo('/manage/account')">付费服务账号</el-menu-item>
            </el-menu-item-group>
        </el-submenu>
        <el-submenu index="2">
            <template slot="title">
                <i class="el-icon-circle-plus-outline"></i>
                <span>秒数联盟数学派</span>
            </template>
            <el-menu-item-group>
                <template slot="title">腾讯媒体资源</template>
                <el-menu-item index="2-1" @click="navigateTo('/manage/channel')">QQ 频道资源</el-menu-item>
                <el-menu-item index="2-2" @click="navigateTo('/manage/group')">QQ 群资源</el-menu-item>
            </el-menu-item-group>
        </el-submenu>
    </el-menu>
</template>
  
<script>
export default {
    name: 'Menu',
    props: {
        defaultActive: {
            type: String,
            default: '1-1'
        }
    },
    methods: {
        navigateTo(targetPath) {
            if (this.$route.path === targetPath) {
                return;
            }
            this.$router.push(targetPath);
        }
    }
}
</script>
  
<style scoped>
.el-menu-vertical {
    width: 200px;
    height: calc(100vh - 60px);
    background-color: #24273b;
    border-right: none;
}
</style>
  